import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material'
import './style.scss'
import { ReactComponent as ArrowBackIosNewIcon } from '../../../lib/icons/LoanIcon_arrow.svg'

function PSelect ({ label, purpose, purposes, handler, className }) {
  const handleChange = (event) => {
    handler(event.target.value)
  }

  return (
    <>
      <Box className={className}>
        {purposes.length === 1 ?
          <>
            <Typography variant="h3">{purposes[0].lp_title}</Typography>
          </>
          :
          <>
            {label && (<Typography variant="h6" className="mb-20">{label}</Typography>)}
            <FormControl className="calc-select-wrapper">
              <Select
                className="calc-select-input"
                value={purpose}
                onChange={handleChange}
                inputProps={{ 'aria-label': 'Without label', 'className': 'calc-select-input-inner' }}
                MenuProps={{
                  PaperProps: {
                    'className': 'calc-select-popup',
                  },
                }}
                IconComponent={ArrowBackIosNewIcon}
              >
                {purposes.map((item, index) => (
                  <MenuItem key={'p_' + index} value={index} className="calc-select-item">
                    {item.lp_title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </>
        }
      </Box>
    </>
  )
}

export default PSelect
